/**
 *
 * key
 *
 */

 const key = 'Y2xpZW50RGV0YWlsc1JlcG9ydA=='

 export default key
 